import { Scenarios } from '@jfs/network'

const getDmrTransactions = {
  default: [
    {
      url: /transaction\/history/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          transactions: [
            {
              idempotentKey: '3559968206156070',
              businessDate: '2024-10-18',
              invoice: '5030843413638340',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '1012',
              status: 'SUCCESS',
              payerMobileNo: '8689906641',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '9641485924780631',
              businessDate: '2024-10-29',
              invoice: '0141281086581999',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '1012',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '7034136027145588',
              businessDate: '2024-10-29',
              invoice: '1893406995357956',
              transactionDescription: 'DMR-BAV_AGENT_REV',
              grossAmount: '1',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '7034136027145588',
              businessDate: '2024-10-29',
              invoice: '1893406995357956',
              transactionDescription: 'DMR-BAV_AGENT',
              grossAmount: '1',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '5681453149199156',
              businessDate: '2024-10-29',
              invoice: '2972984247011422',
              transactionDescription: 'DMR-BAV_AGENT',
              grossAmount: '1',
              status: 'SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '7895924302919047',
              businessDate: '2024-10-29',
              invoice: '3713036708350554',
              transactionDescription: 'DMR-C2A_AGENT_REV',
              grossAmount: '1012',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '7895924302919047',
              businessDate: '2024-10-29',
              invoice: '3713036708350554',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '1012',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '0749597401460203',
              businessDate: '2024-10-29',
              invoice: '4265302936398079',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '1012',
              status: 'FAILED',
              payerMobileNo: '9004458740',
            },
            {
              idempotentKey: '7651355585827727',
              businessDate: '2024-10-29',
              invoice: '4903166988029526',
              transactionDescription: 'DMR-BAV_AGENT',
              grossAmount: '1',
              status: 'FAILED',
              payerMobileNo: '9004458740',
            },
            {
              idempotentKey: '4736169168303437',
              businessDate: '2024-10-29',
              invoice: '5928136570814801',
              transactionDescription: 'DMR-C2A_AGENT_REV',
              grossAmount: '5060',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '4736169168303437',
              businessDate: '2024-10-29',
              invoice: '5928136570814801',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '25300',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '7787782655819710',
              businessDate: '2024-10-29',
              invoice: '6519687651469186',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '1012',
              status: 'FAILED',
              payerMobileNo: '9004458740',
            },
            {
              idempotentKey: '7180136972596549',
              businessDate: '2024-10-29',
              invoice: '7158139366555927',
              transactionDescription: 'DMR-BAV_AGENT',
              grossAmount: '1',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '6291050001',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '9079907786809148',
              businessDate: '2024-10-29',
              invoice: '8250421469732640',
              transactionDescription: 'DMR-BAV_AGENT',
              grossAmount: '1',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '9079907786809148',
              businessDate: '2024-10-29',
              invoice: '8250421469732640',
              transactionDescription: 'DMR-BAV_AGENT_REV',
              grossAmount: '1',
              status: 'PARTIALLY SUCCESS',
              payerMobileNo: '9004458740',
              bankIfsc: 'HDFC0000077',
            },
            {
              idempotentKey: '3925829425006242',
              businessDate: '2024-11-05',
              invoice: '4142520793732876',
              transactionDescription: 'DMR-C2A_AGENT',
              grossAmount: '102',
              status: 'FAILED',
              payerMobileNo: '9004458740',
            },
          ],
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /transaction\/history/,
      method: 'POST',
      responseCode: 55101,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getDmrTransactions }
